import { render, staticRenderFns } from "./createPermissaoAcesso.vue?vue&type=template&id=7287beb6&scoped=true&"
import script from "./createPermissaoAcesso.vue?vue&type=script&lang=js&"
export * from "./createPermissaoAcesso.vue?vue&type=script&lang=js&"
import style0 from "./createPermissaoAcesso.vue?vue&type=style&index=0&id=7287beb6&prod&scoped=true&lang=css&"
import style1 from "./createPermissaoAcesso.vue?vue&type=style&index=1&id=7287beb6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7287beb6",
  null
  
)

export default component.exports